import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useHoverDirty } from 'react-use';
import JBImage from 'components/essentials/JBImage';
import ToggleCTALinkButton from 'components/essentials/ToggleCTALinkButton';
import CtaLink from 'components/essentials/Cta/CtaLink';
const OneSquare = t0 => {
  const $ = _c(34);
  const {
    config: t1
  } = t0;
  const {
    heading,
    subText,
    imageProps,
    cta,
    textColor,
    borderColor,
    borderStyle,
    toggleInputType
  } = t1;
  const oneSquareRef = useRef(null);
  const isHovered = useHoverDirty(oneSquareRef);
  const textColorValue = textColor?.value ?? "Dark";
  const borderColorValue = borderColor?.value ?? "gray";
  const borderStyleValue = borderStyle?.value ?? "straight";
  let t2;
  if ($[0] !== toggleInputType) {
    t2 = toggleInputType && toggleInputType.selected && toggleInputType.selected.value?.replace(" ", "") === "CTALink" && toggleInputType.ctaLink;
    $[0] = toggleInputType;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const hasLink = !!t2;
  const t3 = textColorValue === "Dark";
  const t4 = textColorValue === "Light";
  const t5 = borderColorValue === "none";
  const t6 = borderColorValue === "gray";
  const t7 = borderColorValue === "rainbow";
  const t8 = borderStyleValue === "straight";
  const t9 = borderStyleValue === "rounded";
  let t10;
  if ($[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== t6 || $[6] !== t7 || $[7] !== t8 || $[8] !== t9) {
    t10 = classNames("flex-1 h-[490px] py-10 px-6 relative min-h-[490px] lg:min-h-[560px] lg:ml-5 first:ml-0", {
      "text-gray": t3,
      "text-white": t4,
      "border-none": t5,
      "border border-gray-light6 border-solid": t6,
      "bg-origin-border border-transparent bg-rainbow border-4 border-solid": t7,
      "rounded-none": t8,
      rounded: t9
    });
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== imageProps) {
    t11 = imageProps && imageProps.src ? <JBImage src={imageProps.src} sizes="46vw" className="h-full left-0 object-cover object-center absolute top-0 w-full z-20" /> : null;
    $[10] = imageProps;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== heading) {
    t12 = heading && heading.content && <h3 className="text-2xl font-bold mb-[0.33rem] text-left md:text-center relative z-20">{heading.content}</h3>;
    $[12] = heading;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== subText) {
    t13 = subText && subText.content && <div className="text-base mb-[1.2rem] text-left md:text-center relative z-20">{subText.content}</div>;
    $[14] = subText;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== hasLink || $[17] !== isHovered || $[18] !== toggleInputType) {
    t14 = !!toggleInputType && <div className="lg:text-center relative z-20"><ToggleCTALinkButton toggleInputType={toggleInputType} isHovered={isHovered && hasLink} /></div>;
    $[16] = hasLink;
    $[17] = isHovered;
    $[18] = toggleInputType;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== cta || $[21] !== toggleInputType) {
    t15 = !toggleInputType && cta && cta.content && cta.linkTo && <div className="lg:text-center relative z-20"><CtaLink to={cta.linkTo} className="p-0 text-right">{cta.content}</CtaLink></div>;
    $[20] = cta;
    $[21] = toggleInputType;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== hasLink || $[24] !== toggleInputType) {
    t16 = hasLink && <Link to={toggleInputType.ctaLink.linkTo} className="block h-full left-0 absolute top-0 w-full z-20" tabIndex="-1" />;
    $[23] = hasLink;
    $[24] = toggleInputType;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t12 || $[29] !== t13 || $[30] !== t14 || $[31] !== t15 || $[32] !== t16) {
    t17 = <div className={t10} ref={oneSquareRef}>{t11}{t12}{t13}{t14}{t15}{t16}</div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
};
OneSquare.propTypes = {
  config: PropTypes.shape({
    heading: PropTypes.object,
    subText: PropTypes.shape({
      content: PropTypes.string
    }),
    imageProps: PropTypes.shape({
      src: PropTypes.string
    }),
    cta: PropTypes.shape({
      content: PropTypes.string,
      linkTo: PropTypes.string
    }),
    borderColor: PropTypes.shape({
      value: PropTypes.oneOf(['rainbow', 'gray', 'none'])
    }),
    borderStyle: PropTypes.shape({
      value: PropTypes.oneOf(['rounded', 'straight'])
    }),
    textColor: PropTypes.shape({
      value: PropTypes.oneOf(['Light', 'Dark'])
    }),
    toggleInputType: PropTypes.shape({
      selected: PropTypes.shape({
        value: PropTypes.string
      }),
      ctaLink: PropTypes.shape({
        linkTo: PropTypes.string,
        content: PropTypes.string
      })
    })
  })
};
export default OneSquare;